import { Component } from '@angular/core';
import { AuthService } from '../../auth/services/auth/auth.service';

@Component({
  selector: 'baf-nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent {
  constructor(private authService: AuthService) {}

  isAuthenticated(): boolean {
    return this.authService.isAuthenticatedValue;
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navmenu/navmenu.component.ts